import { useCurrentUser } from './useCurrentUser.js';

const TIER_RANK = Object.freeze({
  viewer: 1,
  supervisor: 2,
  senior: 3,
  admin: 4,
});

/**
 * Returns true if the current user has `minTier` or higher in `moduleCode`.
 * Superadmin (global_role=admin) always returns true.
 * Not signed in / no role → false.
 *
 * @param {'workforce'|'operations'|'client'|'analytics'|'admin'} moduleCode
 * @param {'viewer'|'supervisor'|'senior'|'admin'} [minTier='viewer']
 * @returns {boolean}
 */
export function usePermission(moduleCode, minTier = 'viewer') {
  const { data: user } = useCurrentUser();
  if (!user) return false;
  if (user.global_role === 'admin') return true;

  const actual = user.moduleRoles?.[moduleCode];
  if (!actual) return false;

  return (TIER_RANK[actual] ?? 0) >= (TIER_RANK[minTier] ?? Infinity);
}

/**
 * Returns true if the user has ANY role in the given module OR is a superadmin.
 * Used to render/hide module entries in the sidebar.
 */
export function useHasModuleAccess(moduleCode) {
  const { data: user } = useCurrentUser();
  if (!user) return false;
  if (user.global_role === 'admin') return true;
  return Boolean(user.moduleRoles?.[moduleCode]);
}
